import { requestWasCancelledByUser } from 'src/services/src/service/httpService';

/** Check if an error is Abort/Cancel. needed after canceling an async action with AbortController / redux thunk promise.abort() */
export function isAbortError(error: any | undefined): boolean {
  return error?.name === 'AbortError' || requestWasCancelledByUser(error);
}
